import { StaticPricingTab } from './pricing-display-static.types';

export const RESTFUL_APIS_TAB: StaticPricingTab = {
  id: 'restful-apis',
  label: "RESTful API's",
  sections: [
    {
      title: 'Direct Mail Solution — Transaction Pricing',
      headers: [
        'Tier',
        'Job Transaction Size',
        'Max Records per Tier',
        'Price',
        'Price Per Thousand (Based on Max Records for Tier)',
        'Advanced Quote* (25% of Price)',
      ],
      rows: [
        ['1', '1 – 199 records', '199', '$1.00', '$5.0251', '$0.25'],
        ['2', '200 – 1000 records', '1,000', '$4.00', '$4.0000', '$1.00'],
        ['3', '1,001 – 2,000 records', '2,000', '$6.00', '$3.0000', '$1.50'],
        ['4', '2,001 – 5,000 records', '5,000', '$8.00', '$1.6000', '$2.00'],
        ['5', '5,001 – 10,000 records', '10,000', '$11.00', '$1.1000', '$2.75'],
        [
          '6',
          '10,001 – 20,000 records',
          '20,000',
          '$16.00',
          '$0.8000',
          '$4.00',
        ],
        [
          '7',
          '20,001 – 50,000 records',
          '50,000',
          '$27.00',
          '$0.5400',
          '$6.75',
        ],
        [
          '8',
          '50,001 – 100,000 records',
          '100,000',
          '$48.00',
          '$0.4800',
          '$12.00',
        ],
        [
          '9',
          '100,001 – 1,000,000 records',
          '1,000,000',
          '$88.00',
          '$0.0880',
          '$22.00',
        ],
        [
          '10',
          '1,000,001 – 2,000,000 records',
          '2,000,000',
          '$120.00',
          '$0.0600',
          '$30.00',
        ],
      ],
      notes: [
        {
          type: 'paragraph',
          text: '* Advanced Quote is free if the Job is a billable transaction. If Advanced Quote occurs on a job that is never processed and downloaded, e.g., Nonbillable Transaction, it is free. Exception: If the Total Advanced Quotes for Nonbillable jobs exceeds 50% of the Total Jobs processed for the month, your account will incur the Advanced Quote fee.',
        },
        {
          type: 'list-item',
          text: 'EFI VDP Integration (Digital Store Front)',
        },
        { type: 'list-item', text: 'Enfocus Switch Configurator' },
        { type: 'list-item', text: 'SK&G' },
        { type: 'list-item', text: 'RESTful API Web Service' },
      ],
    },
    {
      title: 'Annual Flat Price to Retain Customer Data on our Servers',
      headers: ['Retention Period', 'Variant', '1 year', '2 years', '3 years'],
      // Code 908; rows come from the DB per variance_code (see
      // DATA_RETENTION_VARIANTS). Prices are 1/2/3 year (12/24/36 month).
      rows: [],
      dynamicSource: 'data-retention',
      notes: [
        {
          type: 'paragraph',
          text: 'AccuTrace Job data will be retained for a minimum of 45-Days from the Job Mail Date. At its discretion, AccuZIP, Inc. may maintain and archive AccuTrace Job data for up to one-year from the Job Mail Date. Guaranteed retention periods are available for purchase and priced based on a retention fee schedule.',
        },
      ],
    },
    {
      title: 'AccuTrace',
      headers: [
        'Product',
        'No Contract - Paid Monthly',
        'Contract - Paid Monthly',
        'Paid Annually',
        '',
      ],
      rows: [
        ['AccuTrace Business Edition', '$900', '$800', '$9,600'],
        ['AccuTrace Enterprise Edition', '$2,000', '$1,600', '$19,200'],
        ['AccuTrace Callback Edition', '', '', '$3,000'],
        ['AccuTrace FTP Nightly Reports', '', '', '$3,000'],
      ],
      notes: [
        {
          type: 'paragraph',
          text: 'FTP Nightly Data Feeds can be scheduled as often as every 15-minutes.',
        },
      ],
    },
    {
      title: 'DQ UI',
      headers: ['Includes', '', '', 'Pricing'],
      rows: [
        [
          'All Direct Mail API functions (CASS, NCOA, Presort, etc)',
          '',
          '',
          'Same As DM API',
        ],
        [
          'Data Enhancement Services (DSF2, ACOA, APT Append, Deceased)',
          '',
          '',
          'Transactional ($1.00, $.75, $.50 per thousand)',
        ],
        [
          'List Purchasing (Business, Consumer, New Mover, New Homeowner)',
          '',
          '',
          '$30/M one time use, $45/M multi use',
        ],
      ],
    },
    {
      title: 'CASS API PRICING',
      headers: [
        'Code',
        'Title',
        'Variant',
        '1 year',
        '2 years',
        '3 years',
        'Volume',
        '$ per unit',
      ],
      // Code/Title/Variant/1-2-3 year prices come from the DB (product_type
      // 'api', codes in CASS_API_PRICING_CODES). Volume/$ per unit derived.
      rows: [],
      dynamicSource: 'cass-api',
    },
  ],
};
